//
//
//
//
//
//
//
//
//

export default {
    props: {
        msg: Object
    },
    data () {
        return {
        }
    },
    computed: {
        link () {
            const { layout_image } = this.msg
            if (layout_image.building_id && layout_image.building_image_id) {
                return `/building/layout_detail/main?building_id=${layout_image.building_id}&layout_id=${layout_image.building_image_id}`
            }
            return ''
        }
    },
    methods: {
    }
}
